import { render, staticRenderFns } from "./AlertsPage.vue?vue&type=template&id=5cd21f28&scoped=true"
import script from "./AlertsPage.vue?vue&type=script&lang=js"
export * from "./AlertsPage.vue?vue&type=script&lang=js"
import style0 from "./AlertsPage.vue?vue&type=style&index=0&id=5cd21f28&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cd21f28",
  null
  
)

export default component.exports